// extracted by mini-css-extract-plugin
export default {"spacePie":"Knob_spacePie__Mx-rO","messageError":"Knob_messageError__Kt-w8"};